export const CSS_CLASSES = {
  RADIO_ROOT: "radio-root",

  RADIO_ROOT_AUTO: "radio-root-auto",
  RADIO_ROOT_FULL: "radio-root-full",

  RADIO_ROOT_AUTO_TOP: "radio-root-auto-top",
  RADIO_ROOT_AUTO_RIGHT: "radio-root-auto-right",
  RADIO_ROOT_AUTO_BOTTOM: "radio-root-auto-bottom",
  RADIO_ROOT_AUTO_LEFT: "radio-root-auto-left",

  RADIO_ROOT_FULL_TOP: "radio-root-full-top",
  RADIO_ROOT_FULL_RIGHT: "radio-root-full-right",
  RADIO_ROOT_FULL_BOTTOM: "radio-root-full-bottom",
  RADIO_ROOT_FULL_LEFT: "radio-root-full-left",

  RADIO_ROOT_DISABLED: "radio-root-disabled",

  RADIO_ICON: "radio-icon",
  RADIO_ICON_INNER_CIRCLE: "radio-icon-inner-circle",

  RADIO_ICON_CHECKED_PRIMARY: "text-primary",
  RADIO_ICON_CHECKED_SECONDARY: "text-secondary",
  RADIO_ICON_CHECKED_INTERACTIVE: "text-interactive",
  RADIO_ICON_CHECKED_ACCENT: "text-accent",
  RADIO_ICON_CHECKED_GRAY: "text-gray",
  RADIO_ICON_CHECKED_ERROR: "text-error",
  RADIO_ICON_CHECKED_WARNING: "text-warning",
  RADIO_ICON_CHECKED_SUCCESS: "text-success",

  RADIO_ICON_UNCHECKED: "text-gray-400",

  RADIO_ICON_DISABLED: "text-gray-300",

  RADIO_LABEL_CONTAINER: "radio-label-container",

  RADIO_LABEL_TOP: "radio-label-top",
  RADIO_LABEL_RIGHT: "radio-label-right",
  RADIO_LABEL_BOTTOM: "radio-label-bottom",
  RADIO_LABEL_LEFT: "radio-label-left",

  RADIO_LABEL_REQUIRED_INDICATOR: "radio-label-required-indicator",

  RADIO_LABEL_TEXT: "radio-label-text",

  RADIO_INPUT_ELEMENT: "radio-input-element",
};
